import { publishEvent } from "#app/fullstory";
import { BackButtonProperties, CreateAccountProperties, FSEvents, SubmittedDotProperties } from "./types";


// SignIn and GetHelp are both on the Registration Layout page, which doesn't have access to state
export function getHelpClicked() {
    publishEvent(FSEvents.GetHelpClicked, {});
};

export function signInClicked() {
    publishEvent(FSEvents.SignInClicked, {});
};

export function submittedDot(properties: SubmittedDotProperties) {
    publishEvent(FSEvents.SubmittedDot, properties);
};

export function createAccountFormSubmitted(properties: CreateAccountProperties) {
    publishEvent(FSEvents.CreateAccountFormSubmitted, properties);
};

export function createAccountBackButtonClicked(properties: BackButtonProperties) {
    publishEvent(FSEvents.CreateAccountBackButtonClicked, properties);
};

export function verifyingInfoBackButtonClicked(properties: BackButtonProperties) {
    publishEvent(FSEvents.VerifyingInfoBackButtonClicked, properties);
};

export function verifyingInfoSupportButtonClicked(properties: BackButtonProperties) {
    publishEvent(FSEvents.VerifyingInfoSupportButtonClicked, properties)
};
